import { getApiClient } from '../utils/apiClient';
let qualityApiBase = 'marketplace/quality/customer/v1';
export const setQualityApiBase = base => {
  qualityApiBase = base;
};
export const reportReview = ({
  reviewId,
  reportReason,
  comment
}) => getApiClient().post(`${qualityApiBase}/reviews/${reviewId}/report`, {
  data: {
    reportReason,
    comment
  }
});
export const reportReply = ({
  reviewId,
  replyId,
  reportReason,
  comment
}) => getApiClient().post(`${qualityApiBase}/reviews/${reviewId}/replies/${replyId}/report`, {
  data: {
    reportReason,
    comment
  }
});